import { useEffect, useRef, useState } from 'react';

declare const bootstrap: any;

interface TruncatedNameProps {
  text: string;
  maxWidth: number;
  className?: string;
}

const TruncatedName = ({ text, maxWidth, className = '' }: TruncatedNameProps) => {
  const spanRef = useRef<HTMLSpanElement>(null);
  const tooltipInstanceRef = useRef<any>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = spanRef.current;
    if (el) setIsTruncated(el.scrollWidth > el.clientWidth);
  }, [text]);

  useEffect(() => {
    const el = spanRef.current;
    if (!el) return;

    if (tooltipInstanceRef.current) {
      tooltipInstanceRef.current.dispose();
      tooltipInstanceRef.current = null;
    }

    if (isTruncated) {
      el.setAttribute('data-bs-original-title', text);
      tooltipInstanceRef.current = new bootstrap.Tooltip(el, {
        title: text,
        delay: { show: 0, hide: 100 }
      });
    }

    return () => {
      tooltipInstanceRef.current?.dispose();
      tooltipInstanceRef.current = null;
    };
  }, [isTruncated, text]);

  return (
    <span
      ref={spanRef}
      className={`text-truncate d-inline-block ${className}`}
      style={{ maxWidth }}
    >
      {text}
    </span>
  );
};

export default TruncatedName;
